export default [
  {
    path: "/posts",
    name: "posts",
    component: () => import("@/views/posts/posting.vue"),
    meta: {
      pageTitle: "Post_Details",
      breadcrumb: [
        {
          text: "Posts",
          active: true,
        },
      ],
    },
  },
];
